import { usePermit2 } from '@/presentation/context/permit2';
import { useNftx, useTransaction } from '@nftx/react';
import { Address, CreateInventoryPositionQuote } from 'nftx.js';

const useCreateInventoryPosition = () => {
  const {
    network,
    provider,
    signer,
    core: { createInventoryPosition },
  } = useNftx();
  const [{ permit2Signature }] = usePermit2();

  return useTransaction(
    ({
      quote,
    }: {
      quote: CreateInventoryPositionQuote;
      userAddress: Address;
    }) => {
      return createInventoryPosition({
        network,
        provider,
        signer,
        quote,
        permit2: permit2Signature,
      });
    }
  );
};

export default useCreateInventoryPosition;
